import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import axiosAPI from "../config/axiosInstance";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../store/userSlice";
import { buttonSpinner } from "../assets/icons";
import { toast } from "react-toastify";
import loginlogo from "../assets/loginLogo.svg";
import ForgotPasswordModal from "./ForgotPassword";
import { setOverLimitChecks } from "../store/userSlice";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError("Email and password are required.");
      return;
    }
    setError("");
    setisLoading(true);
    try {
      const res = await axiosAPI("post", "login", {
        email,
        password,
      });

      if (res.auth) {
        localStorage.setItem("token", res.token);
        dispatch(login({ user: res.user }));
        dispatch(setOverLimitChecks(res.overLimits));
        navigate("/portal/dashboard");
      }
    } catch (error) {
      setisLoading(false);
      toast.error(error.error);
    }
  };

  return (
    <div className="flex min-h-screen w-screen items-center justify-center text-gray-600 bg-gray-50 overflow-hidden">
      <div className="relative p-4">
        <div className="hidden sm:block h-56 w-56 text-indigo-300 absolute a-z-10 -left-20 -top-20">
          <svg
            className="absolute -top-20 -left-20 w-80 h-80"
            viewBox="0 0 200 200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="100" cy="100" r="60" fill="#C4C4C4" />
            <circle cx="90" cy="90" r="60" fill="#3B82F6" />
          </svg>
        </div>
        <div className="hidden sm:block h-28 w-28 text-indigo-300 absolute a-z-10 -right-20 -bottom-20">
          <svg
            className="absolute -bottom-16 -right-16 w-64 h-64"
            viewBox="0 0 200 200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="100" cy="100" r="40" fill="#C4C4C4" />
            <circle cx="90" cy="90" r="40" fill="#3B82F6" />
          </svg>
        </div>
        <div className="relative flex flex-col w-full smd:w-[30rem] rounded-lg border-gray-400 shadow-lg bg-white">
          <div className="flex-auto p-6">
            <div className="mb-2 flex flex-shrink-0 flex-grow-0 items-center justify-center overflow-hidden">
              <Link to="/">
                <img src={loginlogo} alt="" className="h-[60px]" />
              </Link>
            </div>
            <h4 className="mb-2 font-medium text-gray-700 xl:text-xl">
              Welcome back!
            </h4>
            <p className="mb-6 text-gray-500">
              Please sign-in to access your account
            </p>

            <form onSubmit={handleLogin}>
              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="mb-2 inline-block text-xs font-medium uppercase text-gray-700"
                >
                  Email or Username
                </label>
                <input
                  type="text"
                  className="block w-full cursor-text appearance-none rounded-md border border-gray-400 bg--100 py-2 px-3 text-sm outline-none focus:border-indigo-500 focus:bg-white focus:text-gray-600 focus:shadow"
                  id="email"
                  name="email-username"
                  placeholder="Enter your email or username"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoFocus
                />
              </div>
              <div className="mb-4">
                <div className="flex justify-between">
                  <label
                    className="mb-2 inline-block text-xs font-medium uppercase text-gray-700"
                    htmlFor="password"
                  >
                    Password
                  </label>

                  <ForgotPasswordModal open={open} setOpen={setOpen} />
                </div>
                <div className="relative flex w-full flex-wrap items-stretch">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    className="relative block flex-auto cursor-text appearance-none rounded-md border border-gray-400 bg--100 py-2 px-3 text-sm outline-none focus:border-indigo-500 focus:bg-white focus:text-gray-600 focus:shadow"
                    name="password"
                    placeholder="············"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                    <button
                      type="button"
                      className="text-gray-500 hover:text-gray-700 focus:outline-none"
                      onClick={() => setShowPassword((prev) => !prev)}
                    >
                      {showPassword ? <Eye size={18} /> : <EyeOff size={18} />}
                    </button>
                  </div>
                </div>
              </div>

              {error && (
                <div className="mb-4 text-red-500 text-sm">{error}</div>
              )}

              <div className="mb-4">
                <button
                  className="grid w-full cursor-pointer select-none rounded-md border border-indigo-500 bg-lightBlue py-2 px-5 text-center align-middle text-sm text-white shadow hover:border-indigo-600 hover:bg-indigo-600 hover:text-white focus:border-indigo-600 focus:bg-indigo-600 focus:text-white focus:shadow-none"
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? buttonSpinner : "Sign in"}
                </button>
              </div>
            </form>

            <p className="mb-4 text-center">
              New on Ledgerate?
              <Link
                to="/portal/signup"
                className="cursor-pointer text-indigo-500 no-underline hover:text-indigo-500"
              >
                {" "}
                Create an account{" "}
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
